import React from 'react'

export default function (props) {
  return (
    <div>
      <h2>
        Users
        <button
          onClick={props.showAddUsers}
          className="uk-button uk-button-primary uk-button-small uk-align-right uk-margin-small-left"
          type="button"
        >
          <span className="uk-margin-small-right" data-uk-icon="plus-circle" />
          Add Users
        </button>
        <button
          onClick={() => props.onExport()}
          className="uk-button uk-button-default uk-button-small uk-align-right uk-margin-small-left"
          type="button"
        >
          <span className="uk-margin-small-right" data-uk-icon="cloud-download" />
          Team Reports
        </button>
      </h2>

      {(props.currentTeam.users.length === 0) ? (
        <p className="uk-text-center">
          There are no users on this team.
        </p>
      )
        : (
          <table className="uk-table uk-table-divider uk-table-responsive uk-table-middle">
            <thead>
              <tr>
                <th>
                  Team Member
                </th>
                <th>
                  Role
                </th>
                <th>
                  Current Phase
                </th>
                <th>
                  Progress
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {(props.currentTeam.users || []).map((user) => {
                const role = user.role === 'team_admin' ? 'Team Admin' : (user.role === 'admin' ? 'Admin' : 'Member')
                return (
                  <tr key={`row-${user.uuid}`}>
                    <td>
                      <a
                        onClick={() => {
                          props.fetchSelectedUserDetail(props.currentOrganizationId, {
                            ...user,
                            justTeam: props.match.params.team_uuid,
                          })
                        }}
                      >
                        {user.email}
                      </a>
                    </td>
                    <td>{role}</td>
                    <td>
                      {user.active_phases.map((activePhase) => (
                        <div key={activePhase.phase_uuid}>
                          <span className="uk-label uk-label-secondary">{activePhase.phase_title}</span>
                        </div>
                      ))}
                    </td>
                    <td>
                      <progress className="uk-progress" value={user.progress} max="100" />
                    </td>
                    <td>
                      <button
                        onClick={() => {
                          props.showSideBar()
                          props.setSelectedUser(props.currentOrganizationId, user)
                        }}
                        type="button"
                        className="uk-button uk-button-primary uk-button-small uk-align-center"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        )}
    </div>
  )
}
